import React from 'react';
import DroneGoogleMap from './components/Map/DroneGoogleMap';
import InputForm from './components/InputForm/InputForm';
import {Card, Typography} from '@mui/material';
import SampleData from './components/SampleData'

const App = () => {
  const [sampleData, setSampleData] = React.useState('');
  return (
    <div style={{width:"100%", height:"100vh", backgroundColor:'#111113'}}>
    <div style={{ display: "flex", flexDirection: "row" }}>
      <div style={{ width: "30%", padding: "10px", }}>
        <Typography variant="h3" color="#fff" style={{marginTop:"20px",marginBottom:"20px"}}>Drone Simulator</Typography>
        <Card style={{margin:2, padding: 2, backgroundColor:"#18181b"}}>
          <InputForm sampleData={sampleData}/>
        </Card>
        <SampleData onLoadSample={setSampleData} />
      </div>
      <div style={{ width: "70%" }}>
        <DroneGoogleMap />
      </div>
    </div>
    </div>
  );
};

export default App;
